import Form from "../../components/Form";

function Login() {
  return <Form login />;
}

export default Login;
